import { Box, Stack, Divider, styled, Typography } from "@mui/material";

import { useUtilityContent } from "./UtilityContent";
import { useAuthContext } from "../../contexts";
import { formatMoney } from "../../helper";
import { SummaryTitle } from "./SummaryTitle";

export const AmountSummaryCard = ({ header = <SummaryTitle title={"Order Summary"} /> }) => {
  const { amountSummary } = useUtilityContent();
  const { user } = useAuthContext();
  return (
    <div>
      {header}
      <Box sx={{ backgroundColor: "primary.main", padding: "1.5625rem 1.25rem", borderRadius: "1.25rem" }}>
        <Stack spacing={"30px"}>
          <Stack spacing={2}>
            <TitleDatailInline detail={formatMoney(amountSummary?.subTotal, user?.currency)} title={"Subtotal"} />
            <TitleDatailInline detail={formatMoney(amountSummary?.fee, user?.currency)} title={"Fee"} />
          </Stack>
          <Divider />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <BigLabel>Total</BigLabel>
            <BigLabel>{formatMoney(amountSummary?.amountPayable, user?.currency)}</BigLabel>
          </div>
        </Stack>
      </Box>
    </div>
  );
};
const BigLabel = styled(Typography)({
  fontSize: "1.125rem",
  fontWeight: 700,
});
const TitleDatailInline = ({ title, detail }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        "& .MuiTypography-body1": {
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "17px",
        },
      }}
    >
      <Typography sx={{ color: "text.secondary" }}>{title}</Typography>
      <Typography>{detail}</Typography>
    </Box>
  );
};
